module.exports = __webpack_public_path__ + "static/media/metamask.ba08c749.svg";